import {
  Component,
  Injectable,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CampaignService } from '../../../../../common/services/Campaign.service';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SearchService } from '../../../../../common/services/Search.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { FieldService } from '../../../../../common/services/Field.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { EmailService } from '../../../../../common/services/Email.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { Observable } from 'rxjs/Rx';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import { TimeService } from '../../../../../common/services/Time.service';
import { UserService } from '../../../../../common/services/User.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { CampaignType, CampaignTypeArray, DialModeArray } from '../campaign.const';
import { TemplateType } from '../../setting/other/template/template.const';
import { ContactService } from '../../../../../common/services/Contact.service';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { CoreTemplateService } from '../../../../../common/services/CoreTemplate.service';

@Component({
  moduleId: module.id,
  selector: 'campaign-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.css'],
  providers: [
    CampaignService,
    BsModalService,
    SearchService,
    UploadService,
    TimeService,
    GroupService,
    TicketService,
    FieldService,
    CommonService,
    OrganizeService,
    EvsAddressService,
    EmailService,
    IvrgatewayService,
    QueueService,
    UserService,
    ContactService,
    CoreTemplateService,
  ],
})
@Injectable()
export class DetailComponent extends BaseListComponent {
  @ViewChild('filterTemplate') filterTemplate: ElementRef;
  @Output('backMode') backMode = new EventEmitter();
  @Input() campaign_id;
  public currentTab: any = 'contact';
  public modelFilter: any = {};
  public modelCallOut: any = {};
  public message_modal: { class: string; content: string } = null;
  public campaign: any = {};
  public changeBudget = false;
  public changeBudgetOnDay = false;
  public campaignTypes = [{ id: '', text: 'Chọn' }, ...CampaignTypeArray];
  public dialModes = [{ id: '', text: 'Chọn' }, ...DialModeArray];
  public current_budget: any;
  public current_budget_on_day: any;
  public show: any = 'list';
  public step = 1;
  public headers: any = [{ id: '', text: '' }];
  public mapping: any = {};
  public key: any;
  public organizes: any = {};
  public cities: any = {};
  public selected: any = {};
  public agent_list: any;
  public allTemplate: any = [];
  public emailTemplate: any = [];
  public smsTemplate: any = [];
  public znsTemplate: any = [];
  public allEmailAccount: any = [];
  public allGateway: any = [];
  public allQueue: any = [];
  public allSchedule: any = [];
  public file_out: any;
  public listToExport: any = [];
  public exportData: any = [];
  public checkCount = 0;
  public allAgent: Array<any> = [];
  public allGroup: any = [];
  public allUser: any[] = [];
  public typeFilter = 'user';
  public readonly CampaignType = CampaignType;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private campaignService: CampaignService,
    private emailService: EmailService,
    private ivrgatewayService: IvrgatewayService,
    private queueService: QueueService,
    private timeService: TimeService,
    private coreTemplateService: CoreTemplateService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    Observable.forkJoin([
      this.emailService.listAccount({}),
      this.ivrgatewayService.list({}),
      this.queueService.list({}),
      this.timeService.listSchedule({ limit: 500, keyword: '' }),
      this.coreTemplateService.list('all', { limit: 500 }),
    ]).subscribe(data => {
      this.loadEmailAccount(data[0]);
      this.loadIvrGateway(data[1]);
      this.loadQueue(data[2]);
      this.loadSchedule(data[3]);
      this.loadEmailTemplate(data[4]);
      this.detailCampaign();
    });
  }

  loadEmailAccount(res) {
    const emailList = [
      {
        id: '',
        text: '',
      },
    ];
    if (res.status == 200 && res.error == false) {
      res.data.list.forEach(e => {
        emailList.push({
          id: e.ID,
          text: e.ACCOUNT_NAME,
        });
      });

      this.allEmailAccount = emailList;
    }
  }

  loadSchedule(res) {
    const scheduleList = [
      {
        id: '',
        text: '',
      },
    ];
    if (res.status == 200 && res.error == false) {
      res.data.data.forEach(e => {
        scheduleList.push({
          id: e.TIME_SCHEDULE_ID,
          text: e.TIME_SCHEDULE_NAME,
        });
      });

      this.allSchedule = scheduleList;
    }
  }

  loadIvrGateway(res) {
    const allGateway = [
      {
        id: '',
        text: '',
      },
    ];
    if (res.status == 200 && res.error == false) {
      res.data.ivrgateways.forEach(e => {
        allGateway.push({
          id: e.ivrgateway_id,
          text: e.line,
        });
      });
      this.allGateway = allGateway;
    }
  }

  loadQueue(res) {
    const allQueue = [
      {
        id: '',
        text: '',
      },
    ];
    if (res.status == 200 && res.error == false) {
      res.data.queues.forEach(e => {
        allQueue.push({
          id: e.QUEUE_ID,
          text: e.DESCRIPTION,
        });
      });
      this.allQueue = allQueue;
    }
  }

  loadEmailTemplate(res) {
    const templateList = [];
    if (res.status == 200 && res.error == false) {
      res.data.data.forEach(e => {
        templateList.push({
          id: e.id.toString(),
          text: e.template_name,
          type: e.type,
        });
      });
      this.allTemplate = templateList;
      this.emailTemplate = templateList.filter(t => t.type == TemplateType.Email);
      this.smsTemplate = templateList.filter(t => t.type == TemplateType.Sms);
      this.znsTemplate = templateList.filter(t => t.type == TemplateType.Zns);
    }
  }

  openModalCallOut(template: TemplateRef<any>) {
    this.message_modal = null;
    this.agent_list = 'all';
    this.modelCallOut = {
      agent_ids: [],
      group_ids: [],
      max_customer: 1,
    };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  public changeUser(e: any): void {
    this.modelCallOut['agent_ids'] = e.value;
  }

  public changeGroup(e: any): void {
    this.modelCallOut['group_ids'] = e.value;
  }

  submitCallOut() {
    this.message_modal = null;
    let agentList = [];
    if (this.agent_list == 'all') {
      this.allAgent.forEach(agent => {
        agentList.push(agent.id);
      });
    } else if (this.agent_list == 'agent') {
      agentList = this.modelCallOut.agent_ids;
    } else if (this.agent_list == 'group') {
      this.allAgent.forEach(agent => {
        if (this.modelCallOut.group_ids.indexOf(agent.group_id) > -1) {
          agentList.push(agent.id);
        }
      });
    }
    const data = {
      listUserIds: agentList,
      campaignId: this.campaign_id,
      maxCalls: this.modelCallOut.max_customer,
    };
    if (
      this.modelCallOut.max_customer <= 0 ||
      ('' + this.modelCallOut.max_customer).includes('.') ||
      ('' + this.modelCallOut.max_customer).includes('-') ||
      !/^[0-9]*$/.test(this.modelCallOut.max_customer)
    ) {
      this.message_modal = {
        class: 'alert dark alert-danger',
        content: 'Số khách hàng tối đa phải là số nguyên dương',
      };
    }
    if (!this.message_modal) {
      this.is_loading = true;
      this.campaignService.assignAgentCampaign(data).subscribe(res => {
        if (!res.error) {
          this.modalRef.hide();
          this.toastr.success('Phân bổ thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          setTimeout(() => {
            this.loadData();
            this.is_loading = false;
          }, 4500);
        } else {
          this.toastr.error('Có lỗi, vui lòng thử lại sau', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
    }
  }

  detailCampaign() {
    this.campaignService.find(this.campaign_id).subscribe(res => {
      if (!res.error && res.status == 200) {
        this.campaign = res.data;
        this.current_budget = res.data.budget;
        this.current_budget_on_day = res.data.budget_on_day;
      }
    });
  }

  saveCampaign() {
    this.campaign.time_start = this.campaign.time_start ? this.campaign.time_start : $('#time_start').val();
    this.campaign.time_end = this.campaign.time_end ? this.campaign.time_end : $('#time_end').val();
    if (this.campaign.time_start.toString().includes('Indochina Time')) {
      this.campaign.time_start = moment(this.campaign.time_start).utc(true).toISOString();
    } else {
      this.campaign.time_start = moment(this.campaign.time_start).utc(false).toISOString();
    }
    if (this.campaign.time_end.toString().includes('Indochina Time')) {
      this.campaign.time_end = moment(this.campaign.time_end).utc(true).toISOString();
    } else {
      this.campaign.time_end = moment(this.campaign.time_end).utc(false).toISOString();
    }
    let message = null;
    if (!this.campaign.name || this.campaign.name.trim() == '') {
      message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else if (!this.campaign.campaign_type) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Kênh không được bỏ trống !',
      };
    } else if (this.campaign.campaign_type == 'call' && !this.campaign.queue_id) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Queue không được bỏ trống !',
      };
    } else if (this.campaign.campaign_type == 'call' && !this.campaign.dial_mode) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Hình thức không được bỏ trống !',
      };
    } else if (this.campaign.campaign_type == 'email' && !this.campaign.email_account_id) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Tài khoản email không được bỏ trống !',
      };
    } else if (this.campaign.campaign_type == 'email' && !this.campaign.template_id) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Mẫu tin nhắn không được bỏ trống !',
      };
    } else if (!this.campaign.schedule_id) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Lịch làm việc không được bỏ trống !',
      };
    } else if (!this.campaign.time_start) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Thời gian bắt đầu không được bỏ trống !',
      };
    } else if (!this.campaign.time_end) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Thời gian kết thúc không được bỏ trống !',
      };
    } else if (
      this.campaign.time_start &&
      this.campaign.time_end &&
      this.campaign.time_end < this.campaign.time_start
    ) {
      message = {
        class: 'alert dark alert-danger',
        content: 'Thời gian kết thúc không được sớm hơn thời gian bắt đầu !',
      };
    }
    if (message) {
      this.toastr.error(message.content, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      this.campaign.name = this.campaign.name.trim();
      const payload = _.assign({}, this.campaign);
      delete payload._id;
      delete payload.updated_at;
      delete payload.created_at;
      this.campaignService.update(this.campaign_id, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Cập nhật thành công!');
            this.current_budget = payload.budget;
            this.current_budget_on_day = payload.budget_on_day;
            this.changeBudget = false;
            this.changeBudgetOnDay = false;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  changeCampaignType($event) {
    this.campaign.campaign_type = $event.value;
    if ($event.value == 'call') {
      this.campaign.dial_mode = this.campaign.dial_mode ? this.campaign.dial_mode : 'progressive';
    } else {
    }
  }

  changeDialMode($event) {
    this.campaign.dial_mode = $event.value;
  }

  changeTemplate($event) {
    this.campaign.template_id = $event.value;
  }

  changeSchedule($event) {
    this.campaign.schedule_id = $event.value;
  }

  changeEmail($event) {
    this.campaign['email_account_id'] = $event.value;
  }

  changeIvrGateway($event) {
    this.campaign['ivrgateway_id'] = $event.value;
  }

  changeQueue($event) {
    this.campaign['queue_id'] = $event.value;
  }

  backToList() {
    this.backMode.emit({
      mode: 'list',
    });
  }

  changeTab(tab) {
    this.currentTab = tab;
  }
  isEmpty = obj => Object.keys(obj).length === 0;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/detail/detail.component.ts